import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { jsPDF } from "jspdf";
import api from "../../../../api/api";
import ToastMessage from "../../../../utils/mui/righttoptoast";
import { useSelector } from "react-redux";

const ShareConfirmModal = ({ open, onClose, procedure, subview,patid }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [openToast, setOpenToast] = useState(false);

  const practiseid = window.getPracticeId();
  const userConfig = useSelector((state) => state.userconfig);
const fetchPdfBlob = async (pdfUrl) => {
  const proxiedUrl = withProxy(pdfUrl);
  const res = await fetch(proxiedUrl);
  if (!res.ok) throw new Error("Failed to fetch PDF");
  return await res.blob();
};
useEffect(() => {
  if (open) {
    setToastMessage("");
    setToastSeverity("success");
    setOpenToast(false);
    setIsProcessing(false);
  }
}, [open]);
  const handleToastClose = () => setOpenToast(false);
const PROXY =
  "/v2/dallas/v1/onboarding-images/proxy?url=";

const withProxy = (url) =>
  url ? `${PROXY}${encodeURIComponent(url)}` : null;

  if (!open) return null;

  const patientId = procedure?.patientid;

  // ------------------------------------------------------
  // FETCH IMAGING DATA  (no state stored, return directly)
  // ------------------------------------------------------
  const fetchImagingData = async () => {
    try {
      const payload = {
        patientid: patientId,
        imagingresultid:
          subview === 0
            ? procedure.documentclass === "IMAGINGRESULT"
              ? procedure.imagingresultid
              : procedure.encounterdocumentid
            : subview === 1
            ? procedure.imagingresultid
            : procedure.encounterdocumentid,
        category:
          subview === 0
            ? procedure.documentclass === "IMAGINGRESULT"
              ? "Procedures"
              : "ProgressNotes"
            : subview === 1
            ? "Procedures"
            : "ProgressNotes",
      };

      const res = await api.post(
        `/v1/${practiseid}/patient/${patientId}/procedures/image-result`,
        payload
      );

      return res.data || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // ------------------------------------------------------
  // FETCH CLINICAL DOCUMENT DATA
  // ------------------------------------------------------
  const fetchClinicalData = async () => {
    try {
      const payload = {
        patient_id: patientId,
        department_id: userConfig?.config?.departmentid,
        clinicaldocument_id: procedure.clinicaldocumentid,
      };

      const res = await api.post(
        `/v1/${practiseid}/clinical-documents-by-id`,
        payload
      );

      return res.data || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // ------------------------------------------------------
  // FETCH IMAGE URL FOR EACH PAGE
  // ------------------------------------------------------
  const getImageUrls = async (pages) => {
    const urls = [];

    for (const page of pages) {
      try {
        const res = await api.post(
          `/v1/${practiseid}/procedures/get-image`,
          { url: page.href }
        );

        urls.push(res.data || "");
      } catch (err) {
        console.error(err);
      }
    }

    return urls;
  };

  // ------------------------------------------------------
  // HANDLE SHARE (MAIN LOGIC)
  // ------------------------------------------------------
  const base64ToBlob = (dataUrl) => {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
};
//   const handleShare = async () => {
//     setIsProcessing(true);

//     try {
//       // 1️⃣ Fetch correct document
//       let documentData = [];

//       if (
//         subview === 3 ||
//         (subview === 0 && procedure?.documentclass === "CLINICALDOCUMENT")
//       ) {
//         documentData = await fetchClinicalData();
//       } else {
//         documentData = await fetchImagingData();
//       }

//       const pages = documentData[0]?.pages || [];
//       if (!pages.length) throw new Error("No pages found");

//       // 2️⃣ Fetch all images
//       const imageUrls = await getImageUrls(pages);

//       // 3️⃣ Build PDF
//       const pdf = new jsPDF({ unit: "px", format: "a4" });

//       for (let i = 0; i < imageUrls.length; i++) {
//         const img = new Image();

//         await new Promise((resolve) => {
//           img.onload = resolve;
//           img.src = imageUrls[i];
//         });

//         const width = pdf.internal.pageSize.getWidth();
//         const height = (img.height * width) / img.width;

//         if (i > 0) pdf.addPage();
//         pdf.addImage(img, "PNG", 0, 0, width, height);
//       }

//       // 4️⃣ Create blob + preview
//       const pdfBlob = pdf.output("blob");
//       const pdfURL = URL.createObjectURL(pdfBlob);

//       // 🔥 Open PDF Preview in New Tab
//     //   window.open(pdfURL, "_blank");
//   const formData = new FormData();
//       formData.append("attachment", pdfBlob, "document.pdf");
    
// const uploadResponse = await api.post(
//         `/v1/${practiseid}/pcard/${patientId}/dshare`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       if (uploadResponse.status === 200 || uploadResponse.status === 201) {
//         setToastMessage("Document shared successfully");
//         setToastSeverity("success");
//         setOpenToast(true);
//           setTimeout(() => {
//     onClose();
//   }, 1200);

//       } else {
//         throw new Error("Upload failed");
//       }
//     } catch (err) {
//       console.error(err);
//       setToastMessage("Failed to generate preview");
//       setToastSeverity("error");
//       setOpenToast(true);
//     } finally {
//       setIsProcessing(false);
//     }
//   };
const handleShare = async () => {
  setIsProcessing(true);

  try {
    const formData = new FormData();
// ===========================
// 🔥 FORMS SHARE FLOW
// ===========================
if (procedure?.documentclass === "Form") {
  try {
    const pdfUrl = `/chimlw/pdf/questionaireforms/${procedure.id}_${procedure.form_id}.pdf`;

    const pdfBlob = await fetchPdfBlob(pdfUrl);

    const formData = new FormData();
    formData.append("attachment", pdfBlob, "form.pdf");

    const uploadResponse = await api.post(
      `/v1/${practiseid}/pcard/${patid}/dshare`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (uploadResponse.status === 200 || uploadResponse.status === 201) {
      setToastMessage("Form shared successfully");
      setToastSeverity("success");
      setOpenToast(true);

      setTimeout(() => {
        onClose();
      }, 1200);
    } else {
      throw new Error("Upload failed");
    }

    return; // ⛔ stop normal flow
  } catch (err) {
    console.error(err);
    setToastMessage("Failed to share form");
    setToastSeverity("error");
    setOpenToast(true);
    setIsProcessing(false);
    return;
  }
}

    // 🔥 EARLY EXIT FOR OPENEMR
    if (procedure?.source === "openemr") {
      if (!procedure?.imgbasefile) {
        throw new Error("No OpenEMR document found");
      }

      const pdfBlob = base64ToBlob(procedure.imgbasefile);
      formData.append("attachment", pdfBlob, "report.pdf");

      const uploadResponse = await api.post(
        `/v1/${practiseid}/pcard/${patid}/dshare`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (uploadResponse.status === 200 || uploadResponse.status === 201) {
        setToastMessage("Document shared successfully");
        setToastSeverity("success");
        setOpenToast(true);

        setTimeout(() => {
          onClose();
        }, 1200);
      } else {
        throw new Error("Upload failed");
      }

      return; // ⛔ stop further execution
    }

    // ===========================
    // NORMAL FLOW (NON-OPENEMR)
    // ===========================

    let documentData = [];

    if (
      subview === 3 ||
      (subview === 0 && procedure?.documentclass === "CLINICALDOCUMENT")
    ) {
      documentData = await fetchClinicalData();
    } else {
      documentData = await fetchImagingData();
    }

    const pages = documentData[0]?.pages || [];
    if (!pages.length) throw new Error("No pages found");

    const imageUrls = await getImageUrls(pages);

    const pdf = new jsPDF({ unit: "px", format: "a4" });

    for (let i = 0; i < imageUrls.length; i++) {
      const img = new Image();

      await new Promise((resolve) => {
        img.onload = resolve;
        img.src = imageUrls[i];
      });

      const width = pdf.internal.pageSize.getWidth();
      const height = (img.height * width) / img.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(img, "PNG", 0, 0, width, height);
    }

    const pdfBlob = pdf.output("blob");
    formData.append("attachment", pdfBlob, "document.pdf");

    const uploadResponse = await api.post(
      `/v1/${practiseid}/pcard/${patientId}/dshare`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (uploadResponse.status === 200 || uploadResponse.status === 201) {
      setToastMessage("Document shared successfully");
      setToastSeverity("success");
      setOpenToast(true);

      setTimeout(() => {
        onClose();
      }, 1200);
    } else {
      throw new Error("Upload failed");
    }
  } catch (err) {
    console.error(err);
    setToastMessage("Failed to generate preview");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsProcessing(false);
  }
};

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative bg-white p-6 rounded-xl shadow-lg w-[350px] z-50">
        <h2 className="text-lg font-semibold text-[#1d2951]">Share Document</h2>

        <p className="mt-2 text-gray-700">
          Do you want to share this document with the patient?
        </p>

        {isProcessing ? (
          <div className="flex flex-col items-center mt-4">
            <CircularProgress size={28} />
            <p className="text-sm text-gray-600 mt-2">Processing...</p>
          </div>
        ) : (
          <div className="flex justify-end gap-3 mt-6">
            <button
              className="px-4 py-1.5 rounded-lg border text-gray-600"
              onClick={onClose}
            >
              No
            </button>

            <button
              className="px-4 py-1.5 rounded-lg bg-[#5C8496] text-white"
              onClick={handleShare}
            >
              Yes
            </button>
          </div>
        )}
      </div>

      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
    </div>
  );
};

export default ShareConfirmModal;
